module.exports = __webpack_public_path__ + "img/TECHCOMBANK.123e53b4.svg";